// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-shared-components-CustomSnackBar-CustomSnackBar-module__snackbar {
  position: absolute;
  bottom: var(--size-text-2xs);
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/CustomSnackBar/CustomSnackBar.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,4BAAA;EACA,QAAA;AACJ","sourcesContent":[".snackbar {\n    position: absolute;\n    bottom: var(--size-text-2xs);\n    right: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"snackbar": `src-shared-components-CustomSnackBar-CustomSnackBar-module__snackbar`
};
export default ___CSS_LOADER_EXPORT___;
